// Lib
import collate from './collate';

export default (plugins, props) =>
    collate((plugin) => plugin.dynamicDecorators && plugin.dynamicDecorators(props))(plugins);
